
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gear",
      function () {
        return require("private-next-pages/gear.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gear"])
      });
    }
  